<template>
  <div>
      <b-row v-if="saving_params.is_poli_gigi">
        <b-col sm="12">
          <p class="h5 mb-4" style="color: grey;">Riwayat Kesehatan</p>
        </b-col>
        <b-col sm="4" lg="3">
          <b-form-group style="position: relative">
            <strong class="text-grey">Penyakit Jantung</strong>
            <br />
            <template>
              <vue-select
                :options="option_penyakit"
                placeholder="Pilih"
                v-model="riwayatPenyakit['penyakit_jantung']"
                class="__form-select"
                @input="updateData({key: 'penyakit_jantung', value: $event})"
              >
              </vue-select>
            </template>
          </b-form-group>
        </b-col>
        <b-col sm="4" lg="3">
          <b-form-group style="position: relative">
            <strong class="text-grey">Diabetes</strong>
            <br />
            <template>
              <vue-select
                :options="option_penyakit"
                placeholder="Pilih"
                v-model="riwayatPenyakit['diabetes']"
                class="__form-select"
                @input="updateData({key: 'diabetes', value: $event})"
              >
              </vue-select>
            </template>
          </b-form-group>
        </b-col>
        <b-col sm="4" lg="3">
          <b-form-group style="position: relative">
            <strong class="text-grey">Haemopilia</strong>
            <br />
            <template>
              <vue-select
                :options="option_penyakit"
                placeholder="Pilih"
                v-model="riwayatPenyakit['haemopilia']"
                class="__form-select"
                @input="updateData({key: 'haemopilia', value: $event})"
              >
              </vue-select>
            </template>
          </b-form-group>
        </b-col>
        <b-col sm="4" lg="3">
          <b-form-group style="position: relative">
            <strong class="text-grey">Hepatitis</strong>
            <br />
            <template>
              <vue-select
                :options="option_penyakit"
                placeholder="Pilih"
                v-model="riwayatPenyakit['hepatitis']"
                class="__form-select"
                @input="updateData({key: 'hepatitis', value: $event})"
              >
              </vue-select>
            </template>
          </b-form-group>
        </b-col>
        <b-col sm="4" lg="3">
          <b-form-group style="position: relative">
            <strong class="text-grey">Gastring</strong>
            <br />
            <template>
              <vue-select
                :options="option_penyakit"
                placeholder="Pilih"
                v-model="riwayatPenyakit['gastring']"
                class="__form-select __select-relative"
                @input="updateData({key: 'gastring', value: $event})"
              >
              </vue-select>
            </template>
          </b-form-group>
        </b-col>
        <b-col sm="4" lg="3">
          <b-form-group style="position: relative">
            <strong class="text-grey">Penyakit Lainnya</strong>
            <br />
            <template>
              <vue-select
                :options="option_penyakit"
                placeholder="Pilih"
                v-model="riwayatPenyakit['penyakit_lainnya']"
                class="__form-select __select-relative"
                @input="updateData({key: 'penyakit_lainnya', value: $event})"
              >
              </vue-select>
            </template>
          </b-form-group>
        </b-col>
        <b-col sm="4" lg="3">
          <br>
          <b-form-group
            id="fieldset-ket_penyakit_lainnya"
            valid-feedback=""
            :invalid-feedback="'Kolom harus diisi'"
            :state="!isErrorKet"
          >
            <b-form-input
              type="text" id="ket_penyakit_lainnya"
              :class="{'invalid': isErrorKet}"
              v-model="riwayatPenyakit['ket_penyakit_lainnya']"
              @input="updateData({key: 'ket_penyakit_lainnya', value: $event})"
              :disabled="!riwayatPenyakit['penyakit_lainnya'] || (riwayatPenyakit['penyakit_lainnya'] && riwayatPenyakit['penyakit_lainnya'].value != 'Y')"
            />
          </b-form-group>
        </b-col>
      </b-row>
      
      <b-row class="mt-5" :class="{'mb-50': checkObatMakananLain()}">
        <b-col sm="12">
          <p class="h5 mb-4" style="color: grey;" v-if="saving_params.is_poli_gigi">Riwayat Alergi</p>
        </b-col>
        <b-col sm="4" lg="3">
          <b-form-group style="position: relative">
            <strong class="text-grey">Riwayat Penyakit</strong>
            <br />
            <template>
              <b-form-input
                type="text"
                placeholder="Tuliskan riwayat penyakit"
                v-model="riwayatAlergi['riwayat_penyakit']"
                @input="updateData({key: 'riwayat_penyakit', value: $event})"
              />
            </template>
          </b-form-group>
        </b-col>
        <b-col sm="4" lg="3">
          <strong class="text-grey">Riwayat Alergi Obat<label class="mb-0 text-danger" v-if="pcareVersion == '1'">*</label></strong>
          <b-form-group
            id="fieldset-riwayat_alergi_obat"
            valid-feedback=""
            :invalid-feedback="'Kolom harus diisi'"
            :state="stateAlergi('riwayat_alergi_obat')"
          >
            <vue-select
              class="__form-select __select-alergi"
              placeholder="Pilih"
              v-if="pcareVersion == '1'"
              :class="{'select-invalid': !stateAlergi('riwayat_alergi_obat')}"
              :state="stateAlergi('riwayat_alergi_obat')"
              :options="optAlergi['riwayat_alergi_obat']"
              v-model="riwayatAlergi['riwayat_alergi_obat']"
              @input="updateData({key: 'riwayat_alergi_obat', value: $event})"
            >
            </vue-select>
            <b-form-input
              type="text" v-else
              placeholder="Tuliskan alergi obat"
              v-model="riwayatAlergi['riwayat_alergi_obat']"
              @input="updateData({key: 'riwayat_alergi_obat', value: $event})"
            />
          </b-form-group>
        </b-col>
        <b-col sm="4" lg="3" v-if="checkLain('riwayat_alergi_obat')">
          <br>
          <b-form-group
            id="fieldset-ket_riwayat_alergi_obat"
            valid-feedback=""
            :invalid-feedback="'Kolom harus diisi'"
            :state="stateAlergi('ket_riwayat_alergi_obat')"
          >
            <b-form-input
              type="text"
              :class="{'invalid': !stateAlergi('ket_riwayat_alergi_obat')}"
              v-model="riwayatAlergi['ket_riwayat_alergi_obat']"
              @input="updateData({key: 'ket_riwayat_alergi_obat', value: $event})"
            />
          </b-form-group>
        </b-col>
        <b-col sm="4" lg="3">
          <strong class="text-grey">Riwayat Alergi Makanan<label class="mb-0 text-danger" v-if="pcareVersion == '1'">*</label></strong>
          <b-form-group
            id="fieldset-riwayat_alergi_makanan"
            valid-feedback=""
            :invalid-feedback="'Kolom harus diisi'"
            :state="stateAlergi('riwayat_alergi_makanan')"
          >
            <vue-select
              class="__form-select __select-alergi"
              placeholder="Pilih"
              v-if="pcareVersion == '1'"
              :class="{'select-invalid': !stateAlergi('riwayat_alergi_makanan')}"
              :state="stateAlergi('riwayat_alergi_makanan')"
              :options="optAlergi['riwayat_alergi_makanan']"
              v-model="riwayatAlergi['riwayat_alergi_makanan']"
              @input="updateData({key: 'riwayat_alergi_makanan', value: $event})"
            >
            </vue-select>
            <b-form-input
              type="text" v-else
              placeholder="Tuliskan alergi makanan"
              v-model="riwayatAlergi['riwayat_alergi_makanan']"
              @input="updateData({key: 'riwayat_alergi_makanan', value: $event})"
            />
          </b-form-group>
        </b-col>
        <b-col sm="4" lg="3" v-if="checkLain('riwayat_alergi_makanan')">
          <br>
          <b-form-group
            id="fieldset-ket_riwayat_alergi_makanan"
            valid-feedback=""
            :invalid-feedback="'Kolom harus diisi'"
            :state="stateAlergi('ket_riwayat_alergi_makanan')"
          >
            <b-form-input
              type="text"
              :class="{'invalid': !stateAlergi('ket_riwayat_alergi_makanan')}"
              v-model="riwayatAlergi['ket_riwayat_alergi_makanan']"
              @input="updateData({key: 'ket_riwayat_alergi_makanan', value: $event})"
            />
          </b-form-group>
        </b-col>
        <b-col sm="4" lg="3">
          <strong class="text-grey">Riwayat Alergi Udara<label class="mb-0 text-danger" v-if="pcareVersion == '1'">*</label></strong>
          <b-form-group
            id="fieldset-riwayat_alergi_udara"
            valid-feedback=""
            :invalid-feedback="'Kolom harus diisi'"
            :state="stateAlergi('riwayat_alergi_udara')"
          >
            <vue-select
              class="__form-select __select-alergi"
              placeholder="Pilih"
              v-if="pcareVersion == '1'"
              :class="{'select-invalid': !stateAlergi('riwayat_alergi_udara')}"
              :state="stateAlergi('riwayat_alergi_udara')"
              :options="optAlergi['riwayat_alergi_udara']"
              v-model="riwayatAlergi['riwayat_alergi_udara']"
              @input="updateData({key: 'riwayat_alergi_udara', value: $event})"
            >
            </vue-select>
            <b-form-input
              type="text" v-else
              placeholder="Tuliskan alergi udara"
              v-model="riwayatAlergi['riwayat_alergi_udara']"
              @input="updateData({key: 'riwayat_alergi_udara', value: $event})"
            />
          </b-form-group>
        </b-col>
        <b-col sm="4" lg="3">
          <strong class="text-grey">Riwayat Alergi Lain-Lain</strong>
          <b-form-group>
            <b-form-input
              type="text"
              placeholder="Tuliskan alergi lain-lainnya"
              v-model="riwayatAlergi['riwayat_alergi_lain']"
              @input="updateData({key: 'riwayat_alergi_lain', value: $event})"
            />
          </b-form-group>
        </b-col>
        <b-col sm="4" lg="3">
          <strong class="text-grey">Riwayat Pengobatan</strong>
          <b-form-group>
            <b-form-input
              type="text"
              placeholder="Tuliskan alergi pengobatan"
              v-model="riwayatAlergi['riwayat_pengobatan']"
              @input="updateData({key: 'riwayat_pengobatan', value: $event})"
            />
          </b-form-group>
        </b-col>
        <b-col sm="4" lg="3">
          <strong class="text-grey">Keterangan Lain</strong>
          <b-form-group>
            <b-form-input
              type="text"
              placeholder="Tuliskan keterangan lainnya"
              v-model="riwayatAlergi['keterangan_lain']"
              @input="updateData({key: 'keterangan_lain', value: $event})"
            />
          </b-form-group>
        </b-col>
      </b-row>
  </div>
</template>
  
<script>
  import { mapGetters, mapActions } from 'vuex';
  
  export default {
    name: 'SubjectiveRiwayat',
    props: ['pcareVersion', 'ketPenyakitLainErr'],
    components: {
      'vue-select': () => import('@/components/VueSelectClearable.vue'),
    },
    data: () => ({
      option_penyakit: [
        { label: 'Tidak Ada', value: 'T' },
        { label: 'Ada', value: 'Y' }
      ],
      riwayatPenyakit: {
        penyakit_jantung: null,
        diabetes: null,
        haemopilia: null,
        hepatitis: null,
        gastring: null,
        penyakit_lainnya: null,
        ket_penyakit_lainnya: null,
      },
      optAlergi: {
        riwayat_alergi_makanan: [],
        riwayat_alergi_udara: [],
        riwayat_alergi_obat: [],
      },
      riwayatAlergi: {
        riwayat_penyakit: null,
        riwayat_alergi_obat: null,
        ket_riwayat_alergi_obat: null,
        riwayat_alergi_makanan: null,
        ket_riwayat_alergi_makanan: null,
        riwayat_alergi_udara: null,
        riwayat_alergi_lain: null,
        riwayat_pengobatan: null,
        keterangan_lain: null,
      },
      typeAlergi: {
        riwayat_alergi_makanan: 'alergi_makanan_bpjs',
        riwayat_alergi_obat: 'alergi_obat_bpjs',
        riwayat_alergi_udara: 'alergi_udara_bpjs'
      },
      isErrorKet: false,
    }),
    computed: mapGetters(['pasien', 'saving_params', 'trx', 'postData']),
    mounted() {
      this.buildData();
    },
    watch: {
      'trx.diagnosa': function() {
        this.setRiwayatKesehatan(this.trx.diagnosa);
      },
      pasien() {
        this.setRiwayatAlergi(this.pasien);
      },
      pcareVersion() {
        this.buildData();
      },
      ketPenyakitLainErr() {
        this.isErrorKet = this.ketPenyakitLainErr;
      },
    },
    methods: {
      ...mapActions(['updatePostData', 'updatePasien']),
      buildData() {
        this.setOptAlergi();
        this.setRiwayatKesehatan(this.trx.diagnosa);
        this.setRiwayatAlergi(this.pasien);
      },
      updateData(data) {
        this.setUpdateDataPasien(data);

        let obj = ['penyakit_jantung','diabetes','haemopilia','hepatitis','gastring','penyakit_lainnya','ket_penyakit_lainnya'];
        this.isErrorKet = false;
        if (obj.includes(data.key) && this.checkValueData(data.value) && typeof data.value == 'object') {
          data.value = data.value.value;
        }
  
        if (data.key == 'penyakit_lainnya') {
          if (this.checkValueData(data.value) && data.value != 'Y') {
            this.riwayatPenyakit['ket_penyakit_lainnya'] = null;
            this.updatePostData({key: 'ket_penyakit_lainnya', value: null});
          }
        }
        if (data.key == 'ket_penyakit_lainnya') {
          if (this.checkValueData(this.riwayatPenyakit['penyakit_lainnya']) && this.riwayatPenyakit['penyakit_lainnya'].value == 'Y') {
            this.isErrorKet = !this.checkValueData(this.riwayatPenyakit['ket_penyakit_lainnya']);
          }
        }
        if (this.riwayatAlergi.hasOwnProperty(data.key) && this.checkValueData(data.value) && typeof data.value == 'object') {
          this.riwayatAlergi[data.key] = data.value;
          if (['riwayat_alergi_makanan','riwayat_alergi_udara','riwayat_alergi_obat'].includes(data.key)) {
            let key = data.key.replace('riwayat_','');
            this.updatePostData({key: `${key}_bpjs`, value: data.value.value});
            data.value = data.value.label;
          }
        }
        this.updatePostData(data);
        this.$emit('ket-penyakit-lain-err', this.isErrorKet);
        if (!obj.includes(data.key)) this.$emit('update-post-data', {...this.postData, ...data});
      },
      setUpdateDataPasien(data) {
        const fieldRiwayatPasien = [
          'riwayat_penyakit',
          'riwayat_alergi_obat',
          'ket_riwayat_alergi_obat',
          'riwayat_alergi_makanan',
          'ket_riwayat_alergi_makanan',
          'riwayat_alergi_udara',
          'ket_riwayat_alergi_udara',
          'riwayat_alergi_lain',
          'riwayat_pengobatan',
          'keterangan_lain',
        ];
        if (fieldRiwayatPasien.includes(data.key) && this.checkValueData(data.value)) {
          let fieldPasien = {};
          if (this.checkValueData(data.value) && typeof data.value == 'object') {
            if (['riwayat_alergi_makanan','riwayat_alergi_udara','riwayat_alergi_obat'].includes(data.key)) {
              let key = data.key.replace('riwayat_','');
              let fieldPasienBpjs = {};
              fieldPasienBpjs[`${key}_bpjs`] = data.value.value;
              this.updatePasien({ data: {...this.pasien, ...fieldPasienBpjs} });

              fieldPasien[data.key] = data.value.label;
              this.updatePasien({ data: {...this.pasien, ...fieldPasien} });
            }
          } else {
            fieldPasien[data.key] = data.value;
            this.updatePasien({ data: {...this.pasien, ...fieldPasien} });
          }
        }
      },
      setRiwayatKesehatan(data) {
        if (data && this.saving_params.is_poli_gigi) {
          Object.keys(this.riwayatPenyakit).forEach(v => {
            let val = null;
            if (data.hasOwnProperty(v) && data[v]) val = data[v];
  
            if (v == 'ket_penyakit_lainnya') this.riwayatPenyakit[v] = val;
            else this.riwayatPenyakit[v] = this.option_penyakit.find(op => op.value == val);
  
            this.updatePostData({key: v, value: val});
          });
        }
      },
      setRiwayatAlergi(data) {
        Object.keys(this.riwayatAlergi).forEach(v => {
          if (data.hasOwnProperty(v)) {
            this.riwayatAlergi[v] = data[v];

            if (
              this.pcareVersion == '1'
              && this.checkValueData(this.optAlergi[v]) && this.optAlergi[v].length > 0
              && ['riwayat_alergi_makanan','riwayat_alergi_udara','riwayat_alergi_obat'].includes(v)
            ) {
              let x = this.typeAlergi[v] || null;
              this.riwayatAlergi[v] = this.optAlergi[v].find(d => d.value == data[x]);
            }
          }
        });
      },
      stateAlergi(label) {
        let result = true;
        if (this.checkNonAlergiPcare(label)) {
          if (label.includes('ket_') && this.checkLain(label.replace('ket_', ''))) {
            if (!this.checkValueData(this.riwayatAlergi[label])) result = false;
          } else if (!label.includes('ket_') && !this.checkValueData(this.riwayatAlergi[label])) result = false;
        }
        return result;
      },
      checkNonAlergiPcare(label) {
        return this.pcareVersion == '1' && ![
          'riwayat_penyakit',
          'riwayat_alergi_lain',
          'riwayat_pengobatan',
          'keterangan_lain',
        ].includes(label);
      },
      checkLain(label) {
        if (this.pcareVersion == '1' && this.checkValueData(this.riwayatAlergi[label])) {
          let value = this.riwayatAlergi[label].label;
          if (value && value.toLowerCase().includes('lain')) return true;
        }
        return false;
      },
      checkObatMakananLain() {
        let result = [];
        ['riwayat_alergi_obat','riwayat_alergi_makanan'].forEach(k => {
          if (this.checkValueData(this.riwayatAlergi[k]) && typeof this.riwayatAlergi[k] == 'object') {
            let val = this.riwayatAlergi[k].label;
            if (this.checkValueData(val) && val.toLowerCase().includes('lain')) result.push(val);
          }
        });
        return result.length == 1;
      },
      async setOptAlergi() {
        if (this.pcareVersion == '1') {
          if (this.optAlergi.riwayat_alergi_makanan.length < 1) this.optAlergi.riwayat_alergi_makanan = await this.fetchAlergiJenis('01');
          if (this.optAlergi.riwayat_alergi_udara.length < 1) this.optAlergi.riwayat_alergi_udara = await this.fetchAlergiJenis('02');
          if (this.optAlergi.riwayat_alergi_obat.length < 1) this.optAlergi.riwayat_alergi_obat = await this.fetchAlergiJenis('03');

          this.setRiwayatAlergi(this.pasien);
        }
      },
    },
  };
</script>
  
<style>
  .__select-alergi .vs__dropdown-menu {
    max-height: 125px !important;
  }
  .mb-25 {
    margin-bottom: 2.5rem !important;
  }
  .mb-50 {
    margin-bottom: 5rem !important;
  }
  .mb-75 {
    margin-bottom: 7.5rem !important;
  }
  .text-grey {
    font-size : 13px;
    color: grey;
  }
</style>